<div *ngIf="openState === 0">
    <sync-spinner></sync-spinner>
</div>

<app-link-file-list *ngIf="openState === 1"></app-link-file-list>

<app-link-consume-password *ngIf="openState === 2" [errcode]="errcode"
    (password)="onPassword($event)"></app-link-consume-password>

<app-link-error *ngIf="openState === 3" [errcode]="errcode" (linkkey)="onLinkKey($event)"></app-link-error>